import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("cart") || "[]");
        } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(items));
    }, [items]);

    const add = (printItem) => {
        setItems((cur) => {
            const key = `${printItem.id}::${printItem.size_label || ""}`;
            const found = cur.find((c) => `${c.print_id}::${c.size_label || ""}` === key);
            if (found) {
                return cur.map((c) => `${c.print_id}::${c.size_label || ""}` === key ? { ...c, quantity: c.quantity + 1 } : c);
            }
            return [...cur, {
                print_id: printItem.id,
                title: printItem.title,
                price: printItem.price,
                image: printItem.image_url || printItem.image_path,
                medium: printItem.medium,
                size_label: printItem.size_label || null,
                quantity: 1,
            }];
        });
    };

    const remove = (print_id, size_label = null) => setItems((cur) => cur.filter((c) => !(c.print_id === print_id && (c.size_label || null) === size_label)));
    const setQty = (print_id, quantity, size_label = null) => {
        if (quantity <= 0) return remove(print_id, size_label);
        setItems((cur) => cur.map((c) => (c.print_id === print_id && (c.size_label || null) === size_label) ? { ...c, quantity } : c));
    };
    const clear = () => setItems([]);

    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return (
        <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
